import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import React from 'react';
import classnames from 'classnames';
import { defaultProps } from '../utils/defaultProps';
import { iconClass } from './styles';

function Icon() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _objectSpread2(_objectSpread2({}, defaultProps), {}, {
    prefix: 'icon',
    fontFamily: 'iconfont',
    name: '',
    type: 'default'
  });

  var children = props.children,
      prefix = props.prefix,
      type = props.type,
      name = props.name,
      fontFamily = props.fontFamily,
      fontSize = props.fontSize,
      ext = props.ext,
      otherProps = _objectWithoutProperties(props, ["children", "prefix", "type", "name", "fontFamily", "fontSize", "ext"]);

  var className = classnames(iconClass('_', type), props.className, "".concat(prefix, "-").concat(name));
  var style = Object.assign({}, {
    fontFamily: fontFamily,
    fontSize: fontSize
  }, props.style);

  if (ext === 'js') {
    return (
      /*#__PURE__*/
      React.createElement("i", Object.assign({}, otherProps, {
        className: className,
        style: style
      }),
      /*#__PURE__*/
      React.createElement("svg", {
        className: iconClass('svg'),
        "aria-hidden": "true"
      },
      /*#__PURE__*/
      React.createElement("use", {
        xlinkHref: "#".concat(prefix, "-").concat(name)
      })))
    );
  }

  return (
    /*#__PURE__*/
    React.createElement("i", Object.assign({}, otherProps, {
      className: className,
      style: style
    }), children)
  );
}

Icon.defaultProps = _objectSpread2(_objectSpread2({}, defaultProps), {}, {
  prefix: 'icon',
  fontFamily: 'iconfont',
  name: '',
  type: 'default'
});
Icon.displayName = 'ShineoutIcon';
export default Icon;